<template>
    <div>
        <AdminProductList :data="products" product-name="nodutrymningsbeslag" product-code="nb" @on-deleted-item="fetchNb"></AdminProductList>
    </div>
</template>

<script>
    import AdminProductList from "@/components/admin/AdminProductList";
    import ApiServiceAdmin from "@/services/ApiServiceAdmin";
    export default {
        components: {
            AdminProductList
        },
        data() {
            return {
                products: [],
                totalForSlug: {},
                activetab: 1
            }
        },
        methods: {
            fetchNb() {
                ApiServiceAdmin.getNb().then((response) => {
                    this.products = response.data;
                });
            },
        },
        mounted() {
            this.fetchNb();
        },
    }

</script>